import { render, staticRenderFns } from "./CommentEditorParts.vue?vue&type=template&id=6bb00af1&scoped=true"
import script from "./CommentEditorParts.vue?vue&type=script&lang=ts"
export * from "./CommentEditorParts.vue?vue&type=script&lang=ts"
import style0 from "./CommentEditorParts.vue?vue&type=style&index=0&id=6bb00af1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb00af1",
  null
  
)

export default component.exports